import { useReducer } from 'react';

const toggleReducer = <T>(state: T, nextValue?: T): any => nextValue ?? !state;

const useToggle = <T>(initialValue: T): [T, (nextValue?: T) => void] => {
  return useReducer(toggleReducer, initialValue);
};

export default useToggle;
